var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.6 69",
    style: {
      enableBackground: "new 0 0 71.6 69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.7,53.3c-5,5.2-9.6,8.2-9.6,15.5h-15c0-8.9-1.1-11.2,3.9-16.2c2.3-2,16.2-17.1,18.2-17.1c0,0,0.1,0,0.1,0 c1.9-0.1,3.5,1.3,3.6,3.2c0,4.1-10.7,10-11.2,16.4h2.5c0.5-5.9,11.2-10.7,11.2-17.1c0-2.7-3.6-3.2-3.6-5.5V18.7c0-6.6,8.7-6.6,8.7,0 C71.3,43,74,41.9,62.7,53.3z M11.6,35.7c-2.3,0-3.9,1.6-3.9,3.2c0,4.1,10.7,10,11.4,16.2h-2.5C16.2,49.2,5.3,44.4,5.3,38.2 c0-2.7,3.9-3.4,3.9-5.7V18.9c0-6.6-8.9-6.6-8.9,0c0,24.4-2.5,23.2,8.7,34.6c5,5,9.6,8,9.6,15.5h15c0-9.1,1.1-11.2-3.9-16.2 C27.6,50.8,13.5,35.7,11.6,35.7z M35.8,38.9C13.4,23.4,1.8-16,35.8,7C69.9-16,58.3,23.4,35.8,38.9z M37.8,21.4h6.1 c0.2,0,0.3-0.1,0.5-0.2V18c0-0.2-0.2-0.4-0.5-0.5h-6.1v-6.1c0-0.2-0.2-0.4-0.5-0.5h-3.2c-0.2,0-0.2,0.2-0.2,0.5v6.2h-6.1 c-0.2,0-0.4,0.2-0.5,0.5v3.2c0.1,0.1,0.3,0.2,0.5,0.2h6.2v6.1c0,0.2,0,0.5,0.2,0.5h3.2c0.2,0,0.4-0.2,0.5-0.5V21.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.60bcd4e6596411c36ed9c842d54b7b6d.svg";
export { ForwardRef as ReactComponent };